import InboxClassificationFilter from '../store/schema/InboxClassificationFilter';
import InboxClassificationFilterHashtag from '../store/schema/InboxClassificationFilterHashtag';

export default function getHashtagForInboxClassificationFilter(
    inboxClassificationFilter: InboxClassificationFilter
): InboxClassificationFilterHashtag {
    switch (inboxClassificationFilter) {
        case InboxClassificationFilter.None:
        case InboxClassificationFilter.Focused:
        case InboxClassificationFilter.Other:
            return '';
        case InboxClassificationFilter.Promotions:
            return '#Promotions';
        case InboxClassificationFilter.Social:
            return '#Social';
        case InboxClassificationFilter.Newsletters:
            return '#NewslettersPlus';
        default:
            throw new Error(
                'No hashtag for given inbox classification filter' + inboxClassificationFilter
            );
    }
}
